@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.cartypes

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.web.models.CarTypePriority

data class CarTypeAdditionalInfoDto(
    @Suppress("NON_EXPORTABLE_TYPE") val priority: DtoName<CarTypePriority>
)
